import { useCartItems } from './cart_items.hook'

export function useCartTotalAmount() {
  return useCartItems({
    select: (items) => items.reduce((acc, item) => acc + item.amount, 0) ?? 0,
  })
}
